const faqAccordion = (() => {

  const pageFaq = document.getElementById('pageFaq');
  if (pageFaq) {

    let btn = document.querySelectorAll('.js-btn');
    let faqArea = document.querySelectorAll('.js-faq');
    let aInner = document.querySelectorAll('.js-a-inner');
    let aBox = document.querySelectorAll('.js-a-box');



    // for (let i = 0; i < btn.length; i++) {

    //   btn[i].addEventListener('click', (event) => {
    //     let aBoxHight = anserTxt[i].clientHeight;

    //     if (faqArea[i].classList.contains('act') == true) {
    //       faqArea[i].classList.remove('act');
    //       aBox[i].style.height = 0 + 'px';
    //     } else {
    //       faqArea[i].classList.add('act');
    //       aBox[i].style.height = aBoxHight + 'px';
    //     }

    //   });
    // }

    btn.forEach((element, index) => {
      element.addEventListener('click', (event) => {
        let innerHight = aInner[index].clientHeight;

        if (faqArea[index].classList.contains('act') == true) {
          faqArea[index].classList.remove('act');
          aBox[index].style.height = 0 + 'px';
        } else {
          faqArea[index].classList.add('act');
          aBox[index].style.height = innerHight + 'px';
        }

      });
    });


  }

})();
export default faqAccordion;